import React, { useEffect, useState } from 'react';
import { useConfig } from '../../../DataStore/ConfigContext';
import CallOut from '../../Common/CallOut';
import TextInput from '../../Common/TextInput';
import ajaxReport from '../../../util/remote/ajaxReport';
import Notification from '../../Common/Notification';



const NewComment = () => {

    const [currentNotify, setNotify] = useState(null);
    const [commentTitle, setCommentTitle] = useState("");
    const [commentScope, setCommentScope] = useState("");
    const [commentTag, setCommentTag] = useState("");
    const [loading, setLoading] = useState(false);
    const [info, setInfo] = useState("");
    const { getReportCommentConfig } = useConfig();
    

    useEffect(()=>{
        if(currentNotify){
            setTimeout(() => {
                setNotify(null);
            }, 5000);
        }
    }, [currentNotify]);

    const handleSave = async (event) =>{
      event.preventDefault();
      if(commentTitle.length>0 && commentScope.length>0 && commentTag.length>0)
        {
            setLoading(true);
            const server_response = await ajaxReport.configureNewComment(
                {
                    "comment_title":commentTitle,
                    "comment_scope":commentScope,
                    "tag":commentTag
                }
            );
            setLoading(false);
            if(server_response.status==="OK")
            {
                setInfo(<Notification type="success" message={server_response.message}/>)
                setCommentTitle("")
                //Refresh comments
                getReportCommentConfig(true)
            }else{
                setInfo(<Notification type="danger" message={server_response.message}/>)
            }

        }else{
            setInfo(<Notification type="danger" message="Complete all fields"/>)
        }


    }


    const RenderScope=()=>{

        const optionsListing=[
            {label:"General", value:"1"},
            {label:"Specific", value:"2"}
        ];

        return(
            <TextInput
                label="Comment Scope"
                leftIcon="fa fa-bookmark"
                type="select" 
                placeholder="Select comment scope...." 
                options={optionsListing}
                onChange={(e)=>setCommentScope(e.value)}
                leftComponent={<i className="fa fa-bookmark"/>}
                wrap
            />
        )
       
    }


    const RenderTag=()=>{

        const optionsListing=[
            {label:"NORMAL", value:"NORMAL"},
            {label:"FEES-BALANCE", value:"FEES-BALANCE"},
            {label:"FEES-AMOUNT", value:"FEES-AMOUNT"}
        ];

        return(
            <TextInput
                label="Comment Tag"
                leftIcon="fa fa-bookmark"
                type="select" 
                placeholder="Select tag...." 
                options={optionsListing}
                onChange={(e)=>setCommentTag(e.value)}
                leftComponent={<i className="fa fa-tag"/>}
                wrap
            />
        )
   
    }


    return (
        <div className="card-body">

            <CallOut 
                title="Report Comments"
                description="Manage report comments for students. You can create, edit, and delete comments that will be used in student reports. E.g. Head teacher, Next term begins, etc."
             />
            {currentNotify}
            <form className="form-horizontal" method="post" onSubmit={handleSave}>

                {info}
               <TextInput
                    type="text"
                    label="Comment Title"
                    placeholder="Comment Title"
                    leftIcon="fa fa-comment"
                    value={commentTitle}
                    onChange={(e)=>{setCommentTitle(e.target.value)}} 
                    required
                    wrap
                    />
               {RenderScope()}
               {RenderTag()}
    

                <div className="row">&nbsp;</div>


        
                <div className="row">&nbsp;</div>
                
                <div className="modal-footer no-border">
                    <button type="submit" className="btn btn-primary" disabled={loading}>Save Comment</button>
                </div>
                       

            </form> 


        </div>
    );
};

export default NewComment;